<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("Datastore") }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <!-- General -->
                <v-col cols="12">
                  <v-text-field
                    :label="$t('Order')"
                    v-model="order"
                    :class="{'disable-events': !savingEnable}"
                    type="number"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="label"
                    :rules="inputRules"
                    :label="$t('Label')"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    :label="$t('Type')"
                    v-model="dtype"
                    :class="{'disable-events': !savingEnable}"
                    :items="dtypeItems"
                    dense
                  ></v-select>
                </v-col>
                <!-- Folder configuration -->
                <v-col cols="12" v-if="dtype=='FileSystem'">
                  <v-text-field
                    v-model="folderPath"
                    :rules="inputRules"
                    :label="$t('Path')"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="dtype=='FileSystem'">
                  <v-text-field
                    :label="$t('Max Size (%)')"
                    v-model="folderMaxSize"
                    :class="{'disable-events': !savingEnable}"
                    type="number"
                    dense
                  ></v-text-field>
                </v-col>
                <!-- s3 configuration -->
                <v-col cols="12" v-if="dtype=='S3'">
                  <v-text-field
                    v-model="s3Endpoint"
                    :rules="inputRules"
                    label="S3 Endpoint"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="dtype=='S3'">
                  <v-text-field
                    v-model="s3Region"
                    :rules="inputRules"
                    label="S3 Region"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="dtype=='S3'">
                  <v-text-field
                    v-model="s3AccessKey"
                    :rules="inputRules"
                    label="S3 Access Key"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="dtype=='S3'">
                  <v-text-field
                    v-model="s3SecretKey"
                    :rules="inputRules"
                    label="S3 Secret Key"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="dtype=='S3'" class="pb-0">
                  <v-text-field
                    v-model="s3Bucket"
                    :rules="inputRules"
                    label="S3 Bucket"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="dtype=='S3'" class="py-0">
                  <v-switch
                    v-model="s3PathStyle"
                    label="S3 Path Style"
                    :class="{'disable-events': !savingEnable}"
                    dense
                  ></v-switch>
                </v-col>

                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    dense
                    v-show="deleteButton"
                    v-if="savingEnable"
                    @click="remove"
                  >
                    <v-icon left>mdi-delete</v-icon>{{ $t("Delete Datastore") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="hide" text>{{ $t("Close") }}</v-btn>
          <v-btn color="darken-1" @click="save" :disabled="!valid" v-if="savingEnable" text>{{ $t("Save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import i18n from "../../i18n";

export default {
  name: "DatastoreModal",
  data: () => ({
    id: null,
    action: null,
    valid: false,
    showModal: false,
    order: null,
    label: null,
    dtype: null,
    dtypeItems: ["FileSystem", "S3"],
    folderPath: null,
    folderMaxSize: 0,
    s3Endpoint: null,
    s3Region: null,
    s3AccessKey: null,
    s3SecretKey: null,
    s3Bucket: null,
    s3PathStyle: true,
    deleteButton: false,
    savingEnable: false,
    inputRules: [
      v => !!v || i18n.t('Required field')
    ],
  }),
  mounted() {
    let configuration = this.$store.getters.resources.configuration;
    if (configuration.storage.update) {
        this.savingEnable = true;
    }
  },
  methods: {
    show(data, counter, order) {
      if (data == null) {
        // new client
        if (this.$refs.form) this.$refs.form.resetValidation();
        this.deleteButton = false;
        this.id = counter;
        this.order = order+1;
        this.label = "";
        this.dtype = "FileSystem";
        this.folderMaxSize = 0;
        this.s3Endpoint = "";
        this.s3Region = "";
        this.s3AccessKey = "";
        this.s3SecretKey = "";
        this.s3Bucket = "";
        this.s3PathStyle = true;
        this.action = "new";
      } else {
        // update client
        this.deleteButton = true;
        this.id = data.id;
        this.order = data.order;
        this.label = data.label;
        this.dtype = data.dtype;
        this.folderPath = data.folderPath;
        this.folderMaxSize = data.folderMaxSize;
        this.s3Endpoint = data.s3Endpoint;
        this.s3Region = data.s3Region;
        this.s3AccessKey = data.s3AccessKey;
        this.s3SecretKey = data.s3SecretKey;
        this.s3Bucket = data.s3Bucket;
        this.s3PathStyle = data.s3PathStyle;
        this.action = "update";
      }

      this.showModal = true;
    },
    hide() {
      this.loading = false;
      this.showModal = false;
    },
    save() {
      var pathOrBucket;
      if (this.dtype == "FileSystem") {
        pathOrBucket = this.folderPath;
      } else {
        pathOrBucket = this.s3Bucket;
      }
      this.$emit(this.action, {
        id: this.id,
        order: Number(this.order),
        label: this.label,
        dtype: this.dtype,
        folderPath: this.folderPath,
        folderMaxSize: Number(this.folderMaxSize),
        s3Endpoint: this.s3Endpoint,
        s3Region: this.s3Region,
        s3AccessKey: this.s3AccessKey,
        s3SecretKey: this.s3SecretKey,
        s3Bucket: this.s3Bucket,
        s3PathStyle: this.s3PathStyle,
        enabled: true,
        pathOrBucket: pathOrBucket,
      });
      this.hide();
    },
    remove() {
      this.action = "remove";
      this.save();
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
.v-alert {
  overflow: hidden;
}

.disable-events {
  pointer-events: none;
}
</style>